
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOtp] = useState(['', '', '', '']);

  const handleSendOTP = () => {
    if (phone.length >= 9) {
      setShowOTP(true);
    }
  };

  const handleOTPChange = (index: number, value: string) => {
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      
      if (value && index < 3) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput?.focus();
      }
    }
  };

  const handleVerify = () => {
    navigate('/home');
  };

  const handleGuestLogin = () => {
    localStorage.setItem('isGuest', 'true');
    navigate('/home');
  };

  return (
    <div className="min-h-screen w-full bg-[#F6F6F6] flex flex-col">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-16 px-6 rounded-b-[40px]">
        <div className="flex flex-col items-center animate-fadeIn">
          <div className="w-20 h-20 bg-white rounded-2xl shadow-lg flex items-center justify-center mb-4">
            <i className="ri-home-gear-line text-3xl text-[#1565C0]"></i>
          </div>
          <h1 className="text-2xl font-bold text-white">خدماتي بلس</h1>
          <p className="text-white/80 text-sm mt-1">مرحباً بك</p>
        </div>
      </div>

      {/* Form */}
      <div className="flex-1 px-6 -mt-8">
        <div className="bg-white rounded-3xl shadow-lg p-6 animate-slideUp">
          {!showOTP ? (
            <>
              <h2 className="text-lg font-bold text-[#212121] mb-4">تسجيل الدخول</h2>
              
              <div className="mb-4">
                <label className="text-sm text-gray-600 mb-2 block">رقم الجوال</label>
                <div className="flex items-center bg-[#F6F6F6] rounded-xl p-3">
                  <span className="text-gray-500 ml-2">+966</span>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="5xxxxxxxx"
                    className="flex-1 bg-transparent outline-none text-[#212121] text-sm"
                    maxLength={9}
                  />
                </div>
              </div>

              <button
                onClick={handleSendOTP}
                className="w-full bg-[#1565C0] text-white py-3 rounded-xl font-semibold mb-4 hover:bg-[#1565C0]/90 transition-all active:scale-[0.98]"
              >
                إرسال رمز التحقق
              </button>
            </>
          ) : (
            <>
              <h2 className="text-lg font-bold text-[#212121] mb-2">أدخل رمز التحقق</h2>
              <p className="text-sm text-gray-500 mb-4">تم إرسال الرمز إلى {phone}</p>
              
              <div className="flex gap-3 justify-center mb-6" dir="ltr">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    value={digit}
                    onChange={(e) => handleOTPChange(index, e.target.value)}
                    className="w-12 h-12 bg-[#F6F6F6] rounded-xl text-center text-xl font-bold outline-none focus:ring-2 focus:ring-[#1565C0]"
                    maxLength={1}
                  />
                ))}
              </div>

              <button
                onClick={handleVerify}
                className="w-full bg-[#1565C0] text-white py-3 rounded-xl font-semibold mb-4 hover:bg-[#1565C0]/90 transition-all active:scale-[0.98]"
              >
                تحقق
              </button>

              <button
                onClick={() => setShowOTP(false)}
                className="w-full text-[#1565C0] text-sm"
              >
                تغيير رقم الجوال
              </button>
            </>
          )}
        </div>

        {/* Guest Login */}
        <div className="mt-6 animate-slideUp stagger-2">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center">
              <span className="bg-[#F6F6F6] px-4 text-sm text-gray-500">أو</span>
            </div>
          </div>

          <button
            onClick={handleGuestLogin}
            className="w-full mt-6 bg-gradient-to-l from-[#2E7D32] to-[#43A047] text-white py-4 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all active:scale-[0.98]"
          >
            <div className="flex items-center justify-center gap-2">
              <i className="ri-user-line text-xl"></i>
              <span>الدخول كزائر</span>
            </div>
            <p className="text-xs text-white/80 mt-1">تجربة التطبيق بالكامل بدون تسجيل</p>
          </button>
        </div>

        {/* Features */}
        <div className="mt-8 pb-8 animate-fadeIn stagger-3">
          <div className="flex justify-center gap-6">
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 bg-[#1565C0]/10 rounded-full flex items-center justify-center mb-2">
                <i className="ri-shield-check-line text-[#1565C0]"></i>
              </div>
              <span className="text-xs text-gray-500">آمن</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 bg-[#2E7D32]/10 rounded-full flex items-center justify-center mb-2">
                <i className="ri-time-line text-[#2E7D32]"></i>
              </div>
              <span className="text-xs text-gray-500">سريع</span>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 bg-[#FBC02D]/10 rounded-full flex items-center justify-center mb-2">
                <i className="ri-star-line text-[#FBC02D]"></i>
              </div>
              <span className="text-xs text-gray-500">موثوق</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
